
<template>
    <div>

		<div class="app-title">
			<div>
				<h1>Unauthorized</h1>
			</div>
		</div>

        <section class="app-content">
            <div >
                MMF <h1>{{ $t("app.title") }}</h1>
            </div>
        </section>
    </div>    
</template>

<script>
export default {
  name: "unauthorized"
};
</script>
